import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Duration = ({ lang }) => {
  const { t } = useTranslation();

  const [value, setValue] = useState(36); // default value
  const max = 72;
  const percentage = (value / max) * 100;

  const handleChange = (e) => {
    setValue(Number(e.target.value)); // ensure it's number
  };

  return (
    <div className="list-trip">
      <h4>
        {t("duration")}{" "}
        <span className="d-block">{t("maximumTravel")}</span>
      </h4>
      <div className="range-box pt-2">
        <div className="range-container">
          <label htmlFor="timeRange" className="form-label">
            {t("time")} <span>{value}</span> {t("hours")}
          </label>
          <input
            type="range"
            id="timeRange"
            min="0"
            max={max}
            value={value}
            onChange={handleChange}
            style={{
              background: `linear-gradient(to right, #2196f3 ${percentage}%, #e0e0e0 ${percentage}%)`,
              direction: lang === "ar" ? "rtl" : "ltr", // RTL for Arabic
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Duration;
